export default "__VITE_ASSET__Gd7vvd7f__"